import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";

class InternationalTeleHealthStore {
  
  @observable teleHealthCard = {};
  @observable teleHealthList = [];
  @observable count = 0;
  @observable url = "/api/v1/recommendationactions/InternationalTeleHealth";

  @computed get tiles() {
    return parseInt(this.count % 100) > 0 ? parseInt(this.count / 100) + 1 : parseInt(this.count / 100);
  }

  getLength=(data)=>{
    if(!data){
        return 0;
    }

    const inputArray = data.split(',');

    // Use a Set to remove duplicate values
    const uniqueArray = [...new Set(inputArray.filter(Boolean))];
    
    // Get the length and unique values
    return uniqueArray.length;
  }
 
  @action getInternationalTeleHealth = async (data) => {
    this.teleHealthCard = {};
    try {
      let response = await post(
        `${this.url}/getInternationalTeleHealth`,
        data
      );

      let tempData = response.data[0];
      tempData.participant_count=this.getLength(tempData.participant_count);
      tempData.drugs_count=this.getLength(tempData.drugs_count);
      this.teleHealthCard=tempData;

    } catch (err) {
      console.log(err);
    }
  }

  @action getInternationalTeleHealthCount = async (data) => {
    this.count = 0;
    try {
      let response = await post(
        `${this.url}/getInternationalTeleHealthCount`,
        data
      );

      this.count = response.data[0].count;
    } catch (err) {
      console.log(err);
    }
  }

  @action getInternationalTeleHealthList = async (data) => {
    this.teleHealthList = [];
    try {
      let response = await post(
        `${this.url}/getInternationalTeleHealthList`,
        data
      );

      this.teleHealthList = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  


}

export default InternationalTeleHealthStore;
